import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Drawer, Typography, IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import moment from 'moment'
import CircleLoader from 'components/Loading/CircleLoader'
import ConfirmDialog from 'components/common/Popup/ConfirmDialog'
import { fetchEventDataList, deleteEvent } from 'reducers/logbook/reducer'
import withPromise from 'helpers/withPromise'
import messages from '../translate'
import Details from './Details'

class SideInfo extends Component {
  state = {
    isConfirmDialogOpen: false,
  }

  componentDidUpdate(prevProps) {
    const { site, activeDate, open } = this.props
    const { site: prevSite, activeDate: prevDate } = prevProps

    if (
      site &&
      prevSite &&
      (prevSite.id !== site.id || prevDate !== activeDate) &&
      open
    ) {
      this.onClosePanel()
    }
  }

  onDeleteEvent = () => {
    const {
      activeEvent,
      deleteEvent,
      fetchEventDataList,
      activeDateRange,
      storePsfs,
      site,
    } = this.props
    const { id } = activeEvent.toJS()
    const { startDate, endDate } = activeDateRange.toJS()

    withPromise(deleteEvent, { id }).then(() => {
      this.onCloseConfirmDialog()
      this.onClosePanel()
      fetchEventDataList({
        psfs: storePsfs,
        params: {
          site: site.id,
          from: startDate.format('YYYY-MM-DD'),
          to: endDate.format('YYYY-MM-DD'),
        },
      })
    })
  }

  onOpenConfirmDialog = () => {
    this.setState({ isConfirmDialogOpen: true })
  }

  onCloseConfirmDialog = () => {
    this.setState({ isConfirmDialogOpen: false })
  }

  onClosePanel = () => {
    const { onClose, onStopEdit, isEventEditable } = this.props

    if (isEventEditable) {
      onStopEdit()
    }

    onClose()
  }

  render() {
    const {
      site,
      open,
      activeEvent,
      activeDateRange,
      eventLoader,
      onStopEdit,
      onEditEvent,
      isEventEditable,
      storePsfs,
      intl: { formatMessage },
    } = this.props
    const { isConfirmDialogOpen } = this.state
    const { locus, locus_group, event_date, event } = activeEvent.toJS()
    const isEventExist =
      Object.keys(activeEvent.toJS()).length > 0 &&
      Object.keys(event).length > 0

    return (
      <Drawer
        className="info-panel"
        variant="persistent"
        anchor="right"
        open={open}
        classes={{
          paper: 'info-panel-paper',
        }}>
        <CircleLoader loading={eventLoader} />
        <div className="info-panel-header">
          <Typography className="info-title" variant="subtitle1">
            {locus_group && <span>{locus_group.name}</span>}
            {locus && <span>{locus.name}</span>}
            {isEventExist && <span>{formatMessage({ id: event.title })}</span>}
            {event_date && (
              <span>{moment(event_date).format('DD-MM-YYYY')}</span>
            )}
          </Typography>
          <div className="action-group">
            {isEventExist && (
              <>
                <IconButton size="small" onClick={onEditEvent}>
                  <EditIcon />
                </IconButton>
                <IconButton size="small" onClick={this.onOpenConfirmDialog}>
                  <DeleteIcon />
                </IconButton>
              </>
            )}
            <IconButton size="small" onClick={this.onClosePanel}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        {open && (
          <Details
            activeSite={site.id}
            activeDateRange={activeDateRange}
            eventForm={activeEvent}
            isEditable={isEventEditable}
            cancelEditing={onStopEdit}
            storePsfs={storePsfs}
          />
        )}
        <ConfirmDialog
          open={isConfirmDialogOpen}
          title={formatMessage(messages.deleteEvent)}
          message={formatMessage(messages.deleteEventMessage)}
          onClose={this.onCloseConfirmDialog}
          onConfirmAction={this.onDeleteEvent}
        />
      </Drawer>
    )
  }
}

export default connect(
  state => ({
    activeDate: state.getIn(['slaMonitor', 'activeDate']),
    activeDateRange: state.getIn(['sensor', 'dateRange']),
    activeEvent: state.getIn(['logbook', 'eventForm']),
    eventLoader: state.getIn(['logbook', 'eventFormLoader']),
    site: state.getIn(['profile', 'profile', 'site']),
    storePsfs: state.getIn(['logbook', 'storePsfs']),
  }),
  {
    deleteEvent,
    fetchEventDataList,
  },
)(injectIntl(SideInfo))
